import i18next from "i18next";
import { useState } from "react";
import { TbDownload } from "react-icons/tb";
import { useSelector } from "react-redux";
import { getDocument } from "../../../protocols";
import { checkForMIMEType, checkIsAllowedMK, getBookStatus, getColorStatus } from "../../../utils";
import { DownloadBlock, DownloadButton, InfoBlock, ItemTitle, ItemValue, Tooltip, Wrapper } from "./style";

const OrderIdAndStatusComponent = ({ isShowInSmallScreen }) => {
  const { language, t } = i18next;
  const { orderData } = useSelector(state => state.order);
  const [showTooltip, setShowTooltip] = useState(false);

  const isAllowMK = checkIsAllowedMK(orderData?.booking_status);

  const downloadMk = () => {
    const params = {
      type: "mk",
      order_id: orderData.order_id,
      session_id: orderData.session_id,
    };

    // Open blank window immediately to maintain user gesture context
    // This prevents mobile popup blockers
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(
        "<html><head><title>Loading document...</title></head><body><p>Loading document...</p></body></html>"
      );
    }

    getDocument(params, language)
      .then(response => {
        const { pdf } = response?.data;

        checkForMIMEType(pdf, "pdf", newWindow);
      })
      .catch(error => {
        // If API fails, close the blank window
        if (newWindow) {
          newWindow.close();
        }
        console.error("Failed to download document:", error);
      });
  };

  return (
    <Wrapper $isShowInSmallScreen={isShowInSmallScreen}>
      <InfoBlock>
        <div>
          <ItemTitle>{t("order_num")}</ItemTitle>
          <ItemValue>{orderData?.order_id}</ItemValue>
        </div>

        <div>
          <ItemTitle>{t("status")}</ItemTitle>
          <ItemValue>
            <span className="order-id" style={{ backgroundColor: getColorStatus(orderData?.booking_status) }}>
              {getBookStatus(orderData?.booking_status, orderData?.order_status, t)}
            </span>
          </ItemValue>
        </div>
      </InfoBlock>

      {isAllowMK && (
        <DownloadBlock>
          <DownloadButton
            onClick={downloadMk}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            aria-label={t("download_itinerary_receipt")}
          >
            <TbDownload />
            <Tooltip style={{ opacity: showTooltip ? 1 : 0, visibility: showTooltip ? "visible" : "hidden" }}>
              {t("download_itinerary_receipt")}
            </Tooltip>
          </DownloadButton>
        </DownloadBlock>
      )}
    </Wrapper>
  );
};

export default OrderIdAndStatusComponent;
